import { render } from "./Growth.vue?vue&type=template&id=1742c375&scoped=true"
import script from "./Growth.vue?vue&type=script&lang=js"
export * from "./Growth.vue?vue&type=script&lang=js"

import "./Growth.vue?vue&type=style&index=0&id=1742c375&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1742c375"]])

export default __exports__